export const phoneRegexFactory = (mask: string) => {
  const numberBlocks = mask.replaceAll("-", " ").split(" ");
  const regexString = numberBlocks
    .map((block) => `(\\d{${block.length}})`)
    .join("");
  const regex = new RegExp(regexString);
  return regex;
};